const BASE_URL = "https://van.neokred.tech/va/v1/";
export const API_ENDPOINT = {
  basePath: BASE_URL,
};
